<template>
    <!-- 最近チェックした商品 ここから  -->
    <div v-if="getLengthObj(pt320Init.relationList) > 0" class="pt320" id="pt320" v-cloak>
        <div class="itemTitle">
            <h3>{{$t('pt320.labels.recentReviewProduct')}}</h3>
        </div>
        <!-- /.history-inner -->
        <div class="sliderProductList">
            <Carousel :perPageCustom="perPageCustom" :autoplay="true" :navigationEnabled="false" :loop="true" :autoplayTimeout="4000">
                <slide class="sliderProduct" v-for="(item, index) in pt320Init.relationList" :key="index">
                    <router-link :to="{ name: SiteConstants.PG030, params: {pageNo: 3, sItemNo: item.S_ITEM_NO}}" @click.native="reload">
                        <img class="sliderProductImg" :src="item.IMG_URL1" @error="getErrImage" :alt="item.THUMBNAIL_DETAIL"/>
                    </router-link>
                    <router-link :to="{ name: SiteConstants.PG030, params: {pageNo: 3, sItemNo: item.S_ITEM_NO}}" @click.native="reload">
                        <span class="sliderProductNm">{{item.WEB_ITEM_NM}}</span>
                    </router-link>
                </slide>
            </Carousel>
        </div>
    </div><!-- /.history mb32 -->
</template>
<script>
import axios from "assets/js/request";
import common from "assets/js/common";
import { Carousel, Slide } from 'vue-carousel';
import SiteConstants from 'assets/const/SiteConstants.json';
import { mapMutations } from 'vuex';
export default {
    name: "PT320CheckParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components:{
        Carousel,
        Slide
    },
    data() {
        return {
            pt320Init:{
                relationList: [],
                categoryList:[]
            },
            pt320ReqModel: {
            },
            SiteConstants: SiteConstants,
            site: "",
            perPageCustom: [
                [500,7],
                [0,4]
            ]
        }
    },
    watch: {
        pt320Init: {
            handler(value) {
                this.syncPt320InitState(value);
            },
            deep: true,
            immediate: true,
        },
        pt320ReqModel: {
            handler(value) {
                this.syncPt320ReqModelState(value);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        var url = _this.$router.history.current.fullPath.split("/")[2];
        var time = 0;
        // 商品詳細画面の時だけ遅延
        if (url.match(/PG030/)) {
            time = 500;
        }
        if (_this.ptInitData){
            _this.pt320Init = _this.ptInitData;
            _this.perPageCustom[0] = [500,_this.pt320Init.pcNum];
            _this.perPageCustom[1] = [0,_this.pt320Init.spNum];
        }else{
            // 0.5秒遅らせる処理を追加
            setTimeout(function() {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT320 + _this.$UrlConstants.DO_INIT, _this.pt320ReqModel).then(function(response) {
                    //set data init
                    _this.pt320Init = response.data;
                    _this.perPageCustom[0] = [500,_this.pt320Init.pcNum];
                    _this.perPageCustom[1] = [0,_this.pt320Init.spNum];
                }).catch(function(error) {
                    common.errorAPI(error);
                });
            }, time);
        }
    },
    methods: {
        ...mapMutations('pt320', {
            commitSetPt320Init: 'SET_PT320_INIT',
            commitSetPt320ReqModel: 'SET_PT320_REQ_MODEL'
        }),
        syncPt320InitState(payload) {
            this.commitSetPt320Init(Object.assign({}, payload));
        },
        syncPt320ReqModelState(payload) {
            this.commitSetPt320ReqModel(Object.assign({}, payload));
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /*
        * Get length obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * Reload page
         */
        reload: function() {
            window.location.reload();
        },
    },
    created(){
        var _this = this;
        const pt320StoreState = _this.$store && _this.$store.state && _this.$store.state.pt320
            ? _this.$store.state.pt320
            : null;

        if (pt320StoreState) {
            if (pt320StoreState.pt320Init && Object.keys(pt320StoreState.pt320Init).length > 0) {
                _this.pt320Init = Object.assign({}, _this.pt320Init, pt320StoreState.pt320Init);
            }
            if (pt320StoreState.pt320ReqModel && Object.keys(pt320StoreState.pt320ReqModel).length > 0) {
                _this.pt320ReqModel = Object.assign({}, _this.pt320ReqModel, pt320StoreState.pt320ReqModel);
            }
        }

        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;

        if(Object.keys(paramData).length > 0){
            _this.pt320ReqModel = Object.assign({}, _this.pt320ReqModel, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt320ReqModel = Object.assign({}, _this.pt320ReqModel, queryData);
        }
    },
}
</script>
